const AUTH_URL = process.env.REACT_APP_AUTH_URL || '/api/vehicle-auth';
const REGISTRY_URL = process.env.REACT_APP_REGISTRY_URL || '/api/vehicle-registry';
const TELEM_URL = process.env.REACT_APP_TELEM_URL || '/api/vehicle-telem';
const DIAGS_URL = process.env.REACT_APP_DIAGS_URL || '/api/vehicle-diags';

export async function checkAuthHealth() {
  try {
    const response = await fetch(`${AUTH_URL}/health`, {
      method: 'GET',
      signal: AbortSignal.timeout(5000),
    });
    return {
      service: 'vehicle-auth',
      status: response.ok ? 'healthy' : 'unhealthy',
      statusCode: response.status,
    };
  } catch (error) {
    return {
      service: 'vehicle-auth',
      status: 'unreachable',
      error: error.message,
    };
  }
}

export async function checkRegistryHealth() {
  try {
    const response = await fetch(`${REGISTRY_URL}/health`, {
      method: 'GET',
      signal: AbortSignal.timeout(5000),
    });
    return {
      service: 'vehicle-registry',
      status: response.ok ? 'healthy' : 'unhealthy',
      statusCode: response.status,
    };
  } catch (error) {
    return {
      service: 'vehicle-registry',
      status: 'unreachable',
      error: error.message,
    };
  }
}

export async function checkTelemHealth() {
  try {
    const response = await fetch(`${TELEM_URL}/health`, {
      method: 'GET',
      signal: AbortSignal.timeout(5000),
    });
    return {
      service: 'vehicle-telem',
      status: response.ok ? 'healthy' : 'unhealthy',
      statusCode: response.status,
    };
  } catch (error) {
    return {
      service: 'vehicle-telem',
      status: 'unreachable',
      error: error.message,
    };
  }
}

export async function checkDiagsHealth() {
  try {
    const response = await fetch(`${DIAGS_URL}/health`, {
      method: 'GET',
      signal: AbortSignal.timeout(5000),
    });
    return {
      service: 'vehicle-diags',
      status: response.ok ? 'healthy' : 'unhealthy',
      statusCode: response.status,
    };
  } catch (error) {
    return {
      service: 'vehicle-diags',
      status: 'unreachable',
      error: error.message,
    };
  }
}

export async function checkAllHealth() {
  const [auth, registry, telem, diags] = await Promise.all([
    checkAuthHealth(),
    checkRegistryHealth(),
    checkTelemHealth(),
    checkDiagsHealth(),
  ]);
  return { auth, registry, telem, diags };
}
